export default __webpack_public_path__ + "static/media/white-follow.e00b3598.svg";